import { render, staticRenderFns } from "./closure.vue?vue&type=template&id=193122c6&scoped=true"
import script from "./closure.vue?vue&type=script&lang=js"
export * from "./closure.vue?vue&type=script&lang=js"
import style0 from "./closure.vue?vue&type=style&index=0&id=193122c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193122c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193122c6')) {
      api.createRecord('193122c6', component.options)
    } else {
      api.reload('193122c6', component.options)
    }
    module.hot.accept("./closure.vue?vue&type=template&id=193122c6&scoped=true", function () {
      api.rerender('193122c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/closure.vue"
export default component.exports